import { combineReducers } from '@reduxjs/toolkit';
import { persistedReducer as persistedProfileFacilityReducer } from './facility/reducer';
import { reducer as profileUserReducer } from './user/reducer';

export const reducer = combineReducers({
  facility: persistedProfileFacilityReducer,
  user: profileUserReducer,
});
